// extracted by mini-css-extract-plugin
export var headerProduct = "styles-module--header-product--Ebbz7";
export var headerProductContent = "styles-module--header-product-content---TZmN";
export var imageBg = "styles-module--image-bg--3JJ6X";